import React from 'react';
import { withSiteMap } from '../../util/with-site-map';
import { blockToHTML, entityToHTML, setRenderOptions, styleToHTML } from 'medium-draft/lib/exporter';

import { AtomicEmbedComponent } from './AtomicBlock';
import { staticUrl } from '../../lib/config';

let cat = '';

const Script = ({ target, mediaFile, puid8 }) => {
	const location = mediaFile.location;
	const mediaFileId = mediaFile.id;
	const preview = mediaFile.preview ? `${staticUrl}/${mediaFile.preview}` : `${location.replace('.mp4', '')}/preview.jpg`;
	const PREROLL_WEB = `[
        {
			url: 'https://ads.adfox.ru/264443/getCode?p1=bzhdx&p2=fuki&puid1=283&puid2=229103&puid3=187683&puid4=78.ru&puid9=8&puid12=186119&puid13=186102&puid5=99&puid6=9999&puid11=187643&puid51=99&puid50=9999',
		},
		{
			url: 'https://ads.adfox.ru/264443/getCode?p1=bziqm&p2=fuki&puid1=283&puid2=229103&puid3=187684&puid4=78.ru&puid9=8&puid12=186119&puid13=186102&puid5=99&puid6=9999&puid11=187643&puid51=99&puid50=9999',
		}]`;
	const PREROLL_MOB = `[
        {
			url: 'https://ads.adfox.ru/264443/getCode?p1=bzhdx&p2=fuki&puid1=283&puid2=229104&puid3=187683&puid4=78.ru&puid9=8&puid12=186119&puid13=186102&puid5=99&puid6=9999&puid11=187643&puid51=99&puid50=9999',
		},
		{
			url: 'https://ads.adfox.ru/264443/getCode?p1=bziqm&p2=fuki&puid1=283&puid2=229104&puid3=187684&puid4=78.ru&puid9=8&puid12=186119&puid13=186102&puid5=99&puid6=9999&puid11=187643&puid51=99&puid50=9999',
		}]`;
	const shareUrl = withSiteMap(`https://{SITE_MAP}78.ru/player/${mediaFileId}`, process.env.SITEMAP);
	return (
		<script
			type="text/javascript"
			dangerouslySetInnerHTML={{
				__html: `
                function update${target}() {
                    let share = {
                        url: '${shareUrl}'
                    };

                    var config = {
                        width: '100%',
                        height: window.isMobile ? '16rem' : '453px',
                        shareURL: share.url,
                        embed: "<iframe src='" + share.url +"' width='560' height='315' frameborder='0' allowfullscreen></iframe>",
                        source: '${location}', 
                        poster: "${preview}",
                        adVolume: 1.0,
                        adSkipTimeout: 3,
                        midrollTimeout: 20,
                        plugins: {
                        container: [],
                        core: ['VastAds', 'LevelSelector']
                        },
                        VastAds: {
                        preroll: window.isMobile ? ${PREROLL_MOB} : ${PREROLL_WEB},
                        }
                    };

                    if (!window.isMobile) {
                        config.plugins.core.push('SharePlugin');
                    }
                
                    var playerElement = document.getElementById('${target}');
                    playerElement.style.height = window.isMobile ? '16rem' : '453px';
                    config.playerElement = playerElement;
                    var player = new GcorePlayer.gcore(config);
                    player.init();  
                };

                update${target}();
                `,
			}}
		/>
	);
};

const embedScript = data => {
	const twitterEmbedScript = `
    if (!window.hasOwnProperty('twttr')) {
        window.twttr = (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0],
                t = window.twttr || {};
            if (d.getElementById(id)) return t;
            js = d.createElement(s);
            js.id = id;
            js.src = "//platform.twitter.com/widgets.js";
            fjs.parentNode.insertBefore(js, fjs);

            t._e = [];
            t.ready = function(f) {
                t._e.push(f);
            };

            return t;
        }(document, "script", "twitter-wjs"));
    }`;

	const istagramEmbedScript = `
    if (!window.hasOwnProperty('instagramFlag')) {
        window.instagramFlag = true;
        const script = document.createElement('script');
        script.async = 1;
        script.src = '//platform.instagram.com/en_US/embeds.js';
        document.body.appendChild(script);
    }`;

	if (data.hasOwnProperty('provider_name')) {
		switch (data.provider_name) {
			case 'Twitter':
				return twitterEmbedScript;

			case 'Instagram':
				return istagramEmbedScript;

			default:
				break;
		}
	}
};

function myEntityToHTML(e, s) {
	switch (e.type) {
		case 'LINK':
			const url = e.data.url;
			const segment = withSiteMap('{SITE_MAP}78.ru', process.env.SITEMAP);
			if (url.indexOf(segment) !== -1) {
				return (
					<a className="md-inline-link" href={e.data.url}>
						{s}
					</a>
				);
			}
			return (
				<a className="md-inline-link" href={e.data.url} target="_blank" rel="noopener noreferrer">
					{s}
				</a>
			);
		case 'video':
			const _id = Date.now();
			return (
				<div id={_id} className="gplayer" style={{ height: 453, width: 805 }}>
					<span />
					<Script target={_id} mediaFile={e.data} puid8={cat} />
				</div>
			);

		case 'embed':
			return (
				<div>
					<span> </span>
					<script
						type="text/javascript"
						dangerouslySetInnerHTML={{
							__html: embedScript(e.data),
						}}
					/>
					<AtomicEmbedComponent data={e.data} />
				</div>
			);

		case 'slider':
			const { slides } = e.data;
			const hash = Math.random()
				.toString(36)
				.substr(2, 5);
			return (
				<div>
					<span> </span>
					<script
						type="text/javascript"
						dangerouslySetInnerHTML={{
							__html: `
                            var link = document.createElement("link");
                            link.href = 'https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.6.0/tiny-slider.css';
                            link.type = "text/css";
                            link.rel = "stylesheet";
                            document.head.appendChild(link);

                            var css = '.tns-item { margin: 0 !important } .tns-outer { margin-bottom: 30px; position: relative; } .tns-nav { text-align: center; margin: 10px 0; position: absolute; bottom: 50px; left: 0; z-index: 10; right: 0; } .tns-nav > [aria-controls] { width: 10px; height: 10px; padding: 0; margin: 0 5px; border-radius: 50%; background: #fff; border: 0; outline:0; } .tns-nav > [aria-selected="true"] { background: #248dd3; } .tns-controls > [data-controls] { position: absolute; top: calc(50% - 50px);; width: 50px; height: 50px; background-color: rgba(255, 255, 255, 0.35); border: dashed 1px #248dd3; z-index: 10; font-size: 0; outline:0;} .tns-controls > [data-controls="prev"] { left: 30px} .tns-controls > [data-controls="next"] { right: 30px} .tns-controls > [data-controls="prev"]:after { content: ""; display: inline-block; width: 0; height: 0; border-top: 10px solid transparent; border-bottom: 10px solid transparent; border-right: 10px solid #248dd3;} .tns-controls > [data-controls="next"]:after { content: ""; display: inline-block; width: 0; height: 0; border-top: 10px solid transparent; border-bottom: 10px solid transparent; border-left: 10px solid #248dd3;} .is-mobile .tns-controls { display: none; }';
                            var style = document.createElement('style');
                            style.type = 'text/css';
                            if (style.styleSheet){
                              style.styleSheet.cssText = css;
                            } else {
                              style.appendChild(document.createTextNode(css));
                            }
                            document.head.appendChild(style);

                            var script = document.createElement('script');
                            script.onload = function () {
                                var sliders = tns({
                                    container: document.querySelector('.js-slider-${hash}'),
                                    items: 1,
                                    nav: true,
                                    mouseDrag: true,
                                    arrowKeys: true
                                });
                            };
                            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.6.0/min/tiny-slider.js';
                            document.head.appendChild(script);`,
						}}
					/>
					<div className={`js-slider-${hash}`}>
						{slides.map(item => (
							<div>
								<img src={`${staticUrl}/${item.filename}`} alt="#" />
								<p
									style={{
										fontSize: '11px',
										wordBreak: 'break-all',
										marginTop: '10px',
										fontStyle: 'italic',
										fontFamily: 'GothamPro',
										whiteSpace: 'pre-wrap',
									}}
								>
									{item.description}
								</p>
							</div>
						))}
					</div>
				</div>
			);

		default:
			return entityToHTML(e, s);
	}
}

export default function convertToHTML(state, category) {
	cat = category;
	return setRenderOptions({
		styleToHTML: styleToHTML,
		blockToHTML: blockToHTML,
		entityToHTML: myEntityToHTML,
	})(state);
}



// WEBPACK FOOTER //
// src/components/editor/exporter.js